import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { Pricing } from './pages/Pricing';
import { Book } from './pages/Book';
import { Programs } from './pages/Programs';
import { Summer2026 } from './pages/Summer2026';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
export function App() {
  return <Router data-id="element-0">
      <Layout data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Home data-id="element-4" />} data-id="element-3" />
          <Route path="/programs" element={<Programs data-id="element-6" />} data-id="element-5" />
          <Route path="/summer-2026" element={<Summer2026 data-id="element-8" />} data-id="element-7" />
          <Route path="/about" element={<About data-id="element-10" />} data-id="element-9" />
          <Route path="/pricing" element={<Pricing data-id="element-12" />} data-id="element-11" />
          <Route path="/contact" element={<Contact data-id="element-14" />} data-id="element-13" />
          <Route path="/book" element={<Book data-id="element-16" />} data-id="element-15" />
        </Routes>
      </Layout>
    </Router>;
}